import { render, staticRenderFns } from "./Ingest.vue?vue&type=template&id=697743ac&"
import script from "./Ingest.vue?vue&type=script&lang=js&"
export * from "./Ingest.vue?vue&type=script&lang=js&"
import style0 from "./Ingest.vue?vue&type=style&index=0&id=697743ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports